import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CompassReviewDialog } from './compass-review-dialog.component';
import { DirectivesModule } from '../../directives/directive.module';

@NgModule({
  declarations: [
    CompassReviewDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DirectivesModule
  ],
  exports: [
    CompassReviewDialog
  ]
})
export class CompassReviewDialogModule {}
